import { useBooks } from '@/components/Books/Order'
import Icon from '@/components/icon/Icon'
import { Goodnote6, Package } from '@/components/icon/IconList'
import styled from 'styled-components'

const BooksBadge = () => {
	const { isBooks } = useBooks()

	return (
		<BadgeLayout>
			<VendorTextBox>
				<Icon icon={isBooks ? Package : Goodnote6} />
				<VendorText>{isBooks ? '도서 배송' : '굿노트6 eBook'} 상품</VendorText>
			</VendorTextBox>
			<DescriptionText>
				{isBooks
					? '실물 도서가 배송되는 상품입니다.'
					: '굿노트6를 통해 eBook으로 이용가능한 상품입니다.'}
			</DescriptionText>
		</BadgeLayout>
	)
}

export default BooksBadge

const BadgeLayout = styled.div`
	margin-top: 20px;

	display: flex;
	height: 48px;
	padding: 7px 16px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 2px;

	border-radius: 6px;
	background: ${({ theme }) => theme.new.colors.sol_gray_0};
`

const VendorTextBox = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 3px;
	color: ${({ theme }) => theme.new.colors.sol_gray_900};

	svg {
		width: 14px;
		height: 14px;

		color: ${({ theme }) => theme.new.colors.sol_gray_900};
	}
`

const VendorText = styled.span`
	font-size: 12px;
	font-weight: 500;
	line-height: 12px;
`

const DescriptionText = styled.span`
	color: ${({ theme }) => theme.new.colors.sol_gray_500};
	text-align: center;

	/* ref/typo/regular/10 */
	font-size: 10px;
	font-style: normal;
	font-weight: 400;
	line-height: 16px; /* 160% */
`
